import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guard/auth.guard'

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/index/user/dashboard'
      },
      {
        path: 'index',
        loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
      },
      { path: 'file-download/:param1/:encryptedId',
       loadChildren: () => import('./auth/public/file-download/file-download.module')
       .then(m => m.FileDownloadModule)
       },
       { path: 'public',
       loadChildren: () => import('./auth/public/public.module').then(m => m.PublicModule)
       },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { 

}
